export const leftSplit = (split: number): number => {
    const roundedValue = Math.round(split / 5) * 5;
    return Math.min(roundedValue, 100);
};

export const rightSplit = (split: number): number => {
    return Math.max(100 - split, 0);
};
